// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "3.74.1/styles/" + "videojs" + ".chunk.css?" + "a34ca975bfd8299bccd1" + "";
};